import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Bell, CalendarClock, ListChecks, Flag, ChevronDown } from 'lucide-react';
import { API, fmtDate } from './groupMeta';

const ICONS = { inspection: CalendarClock, action: ListChecks, concern: Flag };

export const GroupAlertsBanner = ({ getAuthHeaders, onOpen, refreshKey }) => {
  const [alerts, setAlerts] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    axios.get(`${API}/alerts`, { headers: getAuthHeaders() }).then(r => setAlerts(r.data)).catch(() => {});
  }, [refreshKey]); // eslint-disable-line
  if (!alerts.length) return null;
  const overdue = alerts.filter(a => a.overdue).length;
  return (
    <div className="rounded-2xl border border-amber-400/25 bg-gradient-to-r from-amber-500/[0.07] via-rose-500/[0.05] to-transparent overflow-hidden" data-testid="group-alerts-banner">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-3 px-5 py-3.5 text-left" data-testid="group-alerts-toggle">
        <span className="relative"><Bell className="w-4 h-4 text-amber-300" />{overdue > 0 && <span className="absolute -top-1 -right-1 w-2 h-2 rounded-full bg-rose-400 animate-ping" />}</span>
        <span className="text-sm text-white font-medium">{alerts.length} item{alerts.length > 1 ? 's' : ''} need your attention</span>
        {overdue > 0 && <span className="text-[10px] px-2 py-0.5 rounded-full bg-rose-500/20 text-rose-200 font-semibold">{overdue} urgent</span>}
        <div className="flex-1" />
        <ChevronDown className={`w-4 h-4 text-white/50 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="px-5 pb-4 grid md:grid-cols-2 gap-2">
          {alerts.map((a, i) => {
            const Ic = ICONS[a.kind] || Bell;
            return (
              <button key={i} onClick={() => onOpen(a.group_id)} data-testid={`group-alert-${i}`}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-left border transition-colors hover:bg-white/[0.04] ${a.overdue ? 'border-rose-400/30' : 'border-white/[0.07]'}`}>
                <Ic className={`w-4 h-4 flex-shrink-0 ${a.overdue ? 'text-rose-300' : 'text-amber-300'}`} />
                <div className="min-w-0"><p className="text-xs text-white truncate">{a.title}</p><p className="text-[10px] text-white/45">{a.group_name} · {fmtDate(a.date)}</p></div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
